import { 
  makeStyles,
  createMuiTheme
} from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  BoxDialog: {
    background: '#212121',
    color: '#fff',
  },
  BoxDialogMobile: {
    background: '#212121',
    color: '#fff',
    padding: '5px 10px'
  },
  containerTitle: {
    display: 'flex', 
    justifyContent: 'flex-start', 
    alignItems: 'center', 
    marginBottom: 8, 
    marginTop: 8, 
    width: 'auto'
  },
  ContainerHeader: {
    width: '100%', 
    margin: '5px auto', 
    height: 'auto', 
    display: 'flex', 
    justifyContent: 'space-between'
  },
  DataTypographySmall: {
    width: '15%', 
    color: '#fff', 
    textAlign: 'center'
  },
  DataTypographyNormal: {
    width: '30%', 
    color: '#fff', 
    textAlign: 'center'
  },
  DataTypographyBig: {
    width: '55%', 
    color: '#fff', 
    textAlign: 'center'
  },
  ContainerData: {
    width: '100%', 
    margin: '5px auto', 
    height: '40px', 
    background: '#373435', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    borderRadius: 8
  },
  skeleton: {
    background: '#373435', 
    width: '100%', 
    height: '60px', 
    margin: '5px auto', 
    borderRadius: 8
  }
}));

export const materialTheme = createMuiTheme({
  overrides: {
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#fff',
      },
      input: {
        color: '#fff'           
      }  
    },
    MuiInputLabel: {
      outlined: {
        color: '#fff',
      }
    },
    MuiFormHelperText: {
      contained: {
        color: '#fff',
      }
    },
    MuiButton: {
      label: {
        color: '#fff'           
      }
    },
    MuiInput: {
      root: {
        color: '#fff'
      },
    },
    MuiInputBase: {
      input: {
        cursor: 'pointer'
      }
    }
  },
});